module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-82477c9d.png";